{
  "load_failed": "Det gick inte att ladda enkätdata",
  "not_enabled": "Enkäter är inte aktiverade för denna klubb",
  "prompt": {
    "kicker": "Banans enkät",
    "title": "Ge respons om banan",
    "round_meta": "Rond {{date}}",
    "boolean_true": "Ja",
    "boolean_false": "Nej",
    "scale_low": "Svag",
    "scale_high": "Utmärkt",
    "comment_label": "Kommentar (valfri)",
    "comment_placeholder": "Berätta mer...",
    "submit": "Skicka",
    "skip": "Hoppa över",
    "submitted": "Tack för din respons!",
    "submit_failed": "Det gick inte att skicka responsen"
  },
  "editor": {
    "page_title": "Banenkäter",
    "select_course": "Välj bana",
    "no_courses": "Inga banor",
    "course_section": "Bana",
    "poll_section": "Enkät",
    "chip_locked": "Låst",
    "responses_label": "svar",
    "questions_count_label": "frågor",
    "edit_questions": "Redigera frågor",
    "locked_micro": "Frågorna låstes när det första svaret kom in. Ersätt enkäten om du vill ändra dem.",
    "frequency_label": "Frågefrekvens",
    "frequency": {
      "AFTER_EACH_ROUND": "Efter varje rond",
      "WEEKLY": "En gång i veckan",
      "MONTHLY": "En gång i månaden",
      "ANNUAL": "En gång om året"
    },
    "questions_label": "Frågor",
    "question_text_placeholder": "Skriv en fråga",
    "question_type_label": "Typ",
    "question_type": {
      "BOOLEAN": "Ja/Nej",
      "SCALE": "Skala 1-5"
    },
    "add_question": "Lägg till fråga",
    "remove_question": "Ta bort fråga",
    "move_up": "Flytta upp",
    "move_down": "Flytta ner",
    "fill_all_questions": "Skriv text för varje fråga",
    "create_button": "Skapa enkät",
    "save_button": "Spara ändringar",
    "replace_button": "Ersätt enkät",
    "replace_save_button": "Spara ny enkät",
    "cancel_replace": "Avbryt",
    "archive_button": "Arkivera enkät",
    "locked_notice": "Enkäten har fått svar, så frågorna kan inte längre redigeras. Ersätt enkäten om du vill ändra frågorna.",
    "no_active_poll": "Banan har ingen aktiv enkät.",
    "created": "Enkät skapad",
    "updated": "Enkät uppdaterad",
    "replaced": "Enkät ersatt",
    "archived": "Enkät arkiverad",
    "archive_confirm_header": "Arkivera enkät",
    "archive_confirm_button": "Arkivera",
    "archive_confirm_body": "Vill du verkligen arkivera enkäten? Banan har därefter ingen aktiv enkät förrän du skapar en ny.",
    "response_count": "{{count}} svar",
    "status_active": "Aktiv"
  },
  "results": {
    "title": "Resultat",
    "answered_yes": "Svarade ja",
    "no_responses": "Inga svar",
    "average": "Medelvärde",
    "median": "Median",
    "distribution_title": "Fördelning",
    "trend_title": "Utveckling per månad",
    "no_comments": "Inga kommentarer"
  },
  "report": {
    "kicker": "Banans enkät · Resultat",
    "kicker_questions": "Banans enkät · Frågor",
    "kicker_new": "Banans enkät · Ny enkät",
    "period_label": "Period",
    "comments_stat": "kommentarer",
    "overall_average": "totalt medelvärde",
    "n_count": "n={{count}}",
    "med_tick": "Med {{value}}",
    "vs_month": "vs. {{month}}",
    "pp_value": "{{value}} pp",
    "yes_no_label": "ja / nej",
    "open_feedback": "Öppen feedback",
    "comments_count": "{{count}} kommentarer",
    "export_pdf": "Ladda ner PDF",
    "pdf_title": "Baneförfrågan",
    "pdf_page": "Sida {{page}} / {{pages}}"
  },
  "history": {
    "archive_section": "Arkiv",
    "empty": "Inga arkiverade enkäter",
    "archived": "Arkiverad"
  }
}
